module.exports = __webpack_public_path__ + "img/ignis2021.744314ba.svg";